export default function generateCsrfToken(length = 32) {
    // Create a byte array of the specified length
    const bytes = new Uint8Array(length);
    // Use the crypto API to populate the array with random values
    window.crypto.getRandomValues(bytes);
    // Convert the byte array to a hexadecimal string
    return Array.from(bytes).map(b => b.toString(16).padStart(2, '0')).join('');
}